(function (angular, app) {
   "use strict";

   app.modules.member = {
      name: "app.Member"
      , constants : {
      }
      , controllers : {
      }
      , decorators : {
      }
      , directives : {
         accesscontrol: "ggAccessControlDirective"
         , memberpicker: "ggMemberPickerDirective"
      }
      , filters : {
      }
      , services : {
         accesscontrol : "ggAccessControlFactory"
         , detail : "ggMemberDetailServices"
         , search : "ggMemberSearchFactory"
      }
      , routes : {
          profile : {
            path : "/member/profile"
            , controller : "ggProfileController"
            , controllerAs : "ggProfileCtrl"
            , templateUrl : "app/member/controllers/profile.html"
            , features : {
               showHeading : true
            }
            , accessControl : {
                roles: ["AUTHENTICATED"]
                , roleCheckType : 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , timeline: {
            path: "/member/timeline"
            , controller: "ggTimelineController"
            , controllerAs: "ggTimelineCtrl"
            , templateUrl: "app/member/controllers/timeline.html"
            , features: {
               showHeading: true
            }
            , accessControl: {
               roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , outings: {
            path: "/member/outings"
            , controller: "ggMyOutingsController"
            , controllerAs: "ggMyOutingsCtrl"
            , templateUrl: "app/member/controllers/outings.html"
            , features: {
               showHeading: true
            }
            , accessControl: {
               roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , scoring : {
            path : "/member/scoring"
            , controller : "ggScoringController"
            , controllerAs : "ggScoringCtrl"
            , templateUrl : "app/member/controllers/scoring.html"
            , features : {
               showHeading : true
            }
            , accessControl : {
                roles: ["AUTHENTICATED"]
                , roleCheckType : 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , handicaplookup : {
            path : "/member/lookup"
            , controller : "ggHandicapLookupController"
            , controllerAs : "ggHandicapLookupCtrl"
            , templateUrl : "app/member/controllers/handicaplookup.html"
            , features : {
               showHeading : true
            }
            , detailTemplate: "app/member/controllers/handicaplookup-detail.html"
         }
         , memberdetail: {
            path: "/member/detail"
            , controller: "ggMemberDetailController"
            , controllerAs: "ggMemberDetailCtrl"
            , templateUrl: "app/member/controllers/memberdetail.html"
            , features: {
               showHeading: true
            }
         }
      }
   };
   
   angular.module(app.modules.member.name, []);

}(angular, app));
